import styled, { css } from 'styled-components';
import { dropdownLegendTemplate } from '../RankingTable/RankingTable.styles';
import { defaultTheme } from '../../../../../../utils/defaultTheme';

const flexBoxStyles = (flexDirection, justifyContent) => css`
    display: flex;
    flex-direction: ${flexDirection};
    justify-content: ${justifyContent};
    align-items: center;
`;

const EvolutionCombinedChartSectionWrapper = styled.div`
    ${flexBoxStyles('row', 'center')};
    flex-wrap: wrap;
    column-gap: 30px;
    row-gap: 30px;
`;

const SectionWrapper = styled.div`
    ${flexBoxStyles('column', 'start')};
    box-shadow: 0px 0px 8px ${defaultTheme.black['29']};
    border-radius: 4px;
    width: min-content;
    padding: 18px;
    flex-wrap: wrap;
    row-gap: 15px;
`;

const ChartSectionHeaderWrapper = styled.div`
    display: grid;
    grid-template-columns: 40% auto;
    grid-template-areas: 'title legend';
    width: 100%;
    height: fit-content;
    column-gap: 30px;
    align-items: center;
`;

const ChartSectionTitle = styled.div`
    grid-area: title;
    ${flexBoxStyles('row', 'center')};
    border-radius: 4px;
    padding: 3px 10px;
    font-size: 16px;
    width: 100%;
    max-width: 100px;
    text-align: center;
    color: ${defaultTheme.white.ff};
`;

const LegendWrapper = styled.div`
    ${flexBoxStyles('row', 'flex-start')};
    flex-wrap: wrap;
    column-gap: 15px;
    label {
        display: block;
        max-width: 80px;
        word-break: break-word;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
`;

const LegendLine = styled.div`
    margin-bottom: 0px;
    line-height: 10px;
    ${dropdownLegendTemplate};
`;

const LegendLabel = styled.label`
    color: ${defaultTheme.blue['900']};
    font-size: 15px;
`;

const ChartSectionChartWrapper = styled.div`
    ${flexBoxStyles('row', 'center')};
    column-gap: 20px;
    width: 100%;
`;

export {
    EvolutionCombinedChartSectionWrapper,
    SectionWrapper,
    ChartSectionHeaderWrapper,
    ChartSectionTitle,
    LegendWrapper,
    LegendLine,
    LegendLabel,
    ChartSectionChartWrapper,
};
